<div class="custom-input d-flex flex-row align-items-center justify-content-center custom-stepper"
    [ngClass]="{'disabled': disabled}">
    <div class="icon-minus mr-2" [ngClass]="{'disabled-minus': inputQuantity === 0}" (click)="minusAction()"></div>
    <div class="mr-2">
        {{ inputQuantity }}
    </div>
    <div class="icon-plus" [ngClass]="{'disabled-plus': disabledPlus}" (click)="plusAction()"></div>
</div>
